module.exports = __webpack_public_path__ + "static/media/nft-YellowPainting.6d4ced2d.png";